import { CryptoUtils } from './crypto-utils';

/**
 * 儲存機制統一管理
 */
export class StorageUtils {

    private static instance: StorageUtils;

    public static getInstance(): StorageUtils {
        if (StorageUtils.instance == null) {
            StorageUtils.instance = new StorageUtils();
        }
        return StorageUtils.instance;
    }

    setToSessionStorage(key, value): void {
        const t = typeof value === 'object' ? JSON.stringify(value) : value;
        const v = CryptoUtils.getInstance().enc(t);
        sessionStorage.setItem(key, v);
    }

    getFromSessionStorage(key): any {
        const value = sessionStorage.getItem(key);
        if (value) {
            const v = CryptoUtils.getInstance().dec(value);
            return this.parseValue(v);
        }
        return null;
    }

    /**
     * 儲存File類物件至SessionStorage
     * @param key 
     * @param files 
     */
    setFilesToSessionStorage(key, files): void {
        sessionStorage.setItem(key, JSON.stringify([]));
        files.forEach((file, index) => {
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                const content: any = reader.result;
                const array = Array.from(new Uint8Array(content));
                const fileName = CryptoUtils.getInstance().enc(file.name).toString();
                const fileType = CryptoUtils.getInstance().enc(file.type).toString();
                const encryptedData = CryptoUtils.getInstance().enc(array);
                const item = this.parseValue(sessionStorage.getItem(key)) || [];
                item[index] = { fileName, content: encryptedData, fileType };
                sessionStorage.setItem(key, JSON.stringify(item));
            });
            reader.readAsArrayBuffer(file)
        });
    }

    /**
     * 取得SessionStorage裡File物件
     * @param key 
     * @returns 
     */
    getFilesFromSessionStorage(key) {
        const files = [];
        const item = this.parseValue(sessionStorage.getItem(key)) || [];
        item.forEach(file => {
            const { fileName, content, fileType } = file
            const decryptedName = CryptoUtils.getInstance().dec(fileName).toString();
            const decryptedType = CryptoUtils.getInstance().dec(fileType).toString();
            const decryptedData = CryptoUtils.getInstance().dec(content);
            const uint8Array = new Uint8Array(this.parseValue(decryptedData));
            const blob = new Blob([uint8Array], { type: decryptedType });
            const decryptedFile = new File([blob], decryptedName, { type: fileType });
            files.push(decryptedFile);
        });
        return files;
    }

    removeFromSessionStorage(key): void {
        sessionStorage.removeItem(key);
    }

    clearSessionStorage(): void {
        // sessionStorage.clear();
        for (var i = 0; i < sessionStorage.length; i++){
            // 保留token值
            if('loginService.xAuth' === sessionStorage.key(i)){
                continue;
            }
            this.removeFromSessionStorage(sessionStorage.key(i));
        }
    }

    private parseValue(value: any): any {
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    }

}
